
export function capitalize(label) {
    let fixed = label.replaceAll("_", " ");
    return fixed.toLowerCase().replace(/\b./g, function (a) { return a.toUpperCase(); });
};